//  ID: 301 TO 330
const AccessoriesList =
{
    WatchApiCategory: "AllAccessories",
    AccessoriesData: [
        
        {
            id: 301,
            brand: "Shopster ",
            name: "BLACK MATT FINISH PLAIN MENS & WOMENS FINGER RINGS (PACK OF 1 PIECE) BLACK RING Metal Silver Plated Ring",
            main_img:
                "https://i.postimg.cc/3JvdB5jT/1.jpg",
            item_img_1:
                "https://i.postimg.cc/7Z1hF3Qt/2.jpg",
            item_img_2:
                "https://i.postimg.cc/KYZjx16G/3.jpg",
            item_img_3:
                "https://i.postimg.cc/Y0JjHbHZ/4.jpg",
            item_img_4:
                "https://i.postimg.cc/sf8M7Dhm/5.jpg",
            price: 220,
            old_price: "₹699",
            price_off: "68% off",
            rating: 2.9,
            // qty: 1,
        },
        {
            id: 302,
            brand: "Shopster",
            name: "Adjustable Angel Wings Heart Couple Rings Lovers Valentine Gift for Women & Men Brass, Stainless Steel, Metal, Stone, Copper Cubic Zirconia, Diamond, Crystal Silver Plated Ring Special price",
            main_img:
                "https://i.postimg.cc/26jVC1Bd/2-1.jpg",
            item_img_1:
                "https://i.postimg.cc/tJwTdDvD/2-2.jpg",
            item_img_2:
                "https://i.postimg.cc/3wTkbS8c/2-3.jpg",
            item_img_3:
                "https://i.postimg.cc/wvW3M9hC/2-4.jpg",
            item_img_4:
                "https://i.postimg.cc/6Qf8srT5/2-5.jpg",
            price: 1830,
            old_price: "₹1499",
            price_off: "87% off",
            rating: 2.9,
            // qty: 1,
        },
        {
            id: 303,
            brand: "Shopster CHIMES ",
            name: "Alloy Rhodium Bracelet",
            main_img:
                "https://i.postimg.cc/G2X7K3T3/1-1.jpg",
            item_img_1:
                "https://i.postimg.cc/kMhYt4df/1-2.jpg",
            item_img_2:
                "https://i.postimg.cc/k4JYWR4h/1-4.jpg",
            item_img_3:
                "https://i.postimg.cc/Wzt9HR0G/1-3.jpg",
            item_img_4:
                "https://i.postimg.cc/L57ydyVr/1-5.jpg",
            price: 319,
            old_price: "₹810",
            price_off: "60% off",
            rating: 3.9,
            // qty: 1,
        },
        {
            id: 304,
            brand: "Shopster ",
            name: "Alloy Rhodium White Jewel Set",
            main_img:
                "https://i.postimg.cc/DzPn2GHC/2-1.jpg",
            item_img_1:
                "https://i.postimg.cc/3wT351S4/2-2.jpg",
            item_img_2:
                "https://i.postimg.cc/wjJ9GZVY/2-3.jpg",
            item_img_3:
                "https://i.postimg.cc/3JzK9Y2Z/2-4.jpg",
            item_img_4:
                "https://i.postimg.cc/658Wdy43/2-5.jpg",
            price: 159,
            old_price: "₹1799",
            price_off: "91% off",
            rating: 3.9,
            // qty: 1,
        },
        {
            id: 305,
            brand: "Shopster",
            name: "Alloy Bracelet",
            main_img:
                "https://i.postimg.cc/FHZTNgNC/3-1.jpg",
            item_img_1:
                "https://i.postimg.cc/d0NnTs78/3-2.jpg",
            item_img_2:
                "https://i.postimg.cc/NjYd3Pqr/3-3.jpg",
            item_img_3:
                "https://i.postimg.cc/d0V41k0s/3-4.jpg",
            item_img_4:
                "https://i.postimg.cc/65CH1xSX/3-5.jpg",
            price: 299,
            old_price: "₹899",
            price_off: "66% off",
            rating: 3.9,
            // qty: 1,
        },
        {
            id: 306,
            brand: "Shopster",
            name: "Brass Bracelet",
            main_img:
                "https://i.postimg.cc/hvXGP0kL/4-1.jpg",
            item_img_1:
                "https://i.postimg.cc/hP7Gkpbg/4-2.jpg",
            item_img_2:
                "https://i.postimg.cc/wMnjtmzS/4-3.jpg",
            item_img_3:
                "https://i.postimg.cc/Bn9v4HMF/4-4.jpg",
            item_img_4:
                "https://i.postimg.cc/9XkMgv9J/4-5.jpg",
            price: 289,
            old_price: "₹810",
            price_off: "64% off",
            rating: 3.9,
            // qty: 1,
        },
        {
            id: 307,
            brand: "Shopster",
            name: "Brass Bracelet",
            main_img:
                "https://i.postimg.cc/Pf16xkMR/5-1.jpg",
            item_img_1:
                "https://i.postimg.cc/W3k50Rct/5-2.jpg",
            item_img_2:
                "https://i.postimg.cc/BQsmPwYQ/5-3.jpg",
            item_img_3:
                "https://i.postimg.cc/C5pmNvw7/5-4.jpg",
            item_img_4:
                "https://i.postimg.cc/wM5Fbhvp/5-5.jpg",
            price: 99,
            old_price: "₹700",
            price_off: "85% off",
            rating: 3.9,
            // qty: 1,
        },
        {
            id: 308,
            brand: "Shopster ",
            name: "Oxidised Silver Silver Bracelet",
            main_img:
                "https://i.postimg.cc/P51fVJbM/6-1.jpg",
            item_img_1:
                "https://i.postimg.cc/zXbGW0V6/6-2.jpg",
            item_img_2:
                "https://i.postimg.cc/3rbwdPJ2/6-3.jpg",
            item_img_3:
                "https://i.postimg.cc/N0Ys3tpv/6-4.jpg",
            item_img_4:
                "https://i.postimg.cc/VLxLFnt6/6-5.jpg",
            price: 362,
            old_price: "₹1483",
            price_off: "75% off",
            rating: 3.9,
            // qty: 1,
        },
        {
            id: 309,
            brand: "Shopster CHIMES",
            name: "Leather Bracelet",
            main_img:
                "https://i.postimg.cc/L8JQmgQz/7-1.jpg",
            item_img_1:
                "https://i.postimg.cc/WzSY1GP7/7-2.jpg",
            item_img_2:
                "https://i.postimg.cc/VLLHHVjZ/7-3.jpg",
            item_img_3:
                "https://i.postimg.cc/NGxzDcrr/7-4.jpg",
            item_img_4:
                "https://i.postimg.cc/TY7H8J0d/7-5.jpg",
            price: 309,
            old_price: "₹996",
            price_off: "68% off",
            rating: 3.9,
            // qty: 1,
        },
        {
            id: 400,
            brand: "Shopster ",
            name: "Rubber Bracelet",
            main_img:
                "https://i.postimg.cc/ZKCxNtPm/8-1.jpg",
            item_img_1:
                "https://i.postimg.cc/Vs7F5LC4/8-2.jpg",
            item_img_2:
                "https://i.postimg.cc/CKVG9R3M/8-3.jpg",
            item_img_3:
                "https://i.postimg.cc/YCFNX6yy/8-4.jpg",
            item_img_4:
                "https://i.postimg.cc/xThyyxgz/8-5.jpg",
            price: 279,
            old_price: "₹1450",
            price_off: "80% off",
            rating: 3.9,
            // qty: 1,
        },

    ]
}

export default AccessoriesList;